/* eslint-disable react/jsx-pascal-case */
import {
  Col,
  DatePicker,
  ConfigProvider,
  Form,
  Input,
  Row,
  Button,
  Select,
  TreeSelect
} from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState, useRef } from "react";
// import Label_language from '../../language'
import UploadImg from "../../utility/UploadImg";
import JoditEditor from "jodit-react";
import axios from "axios";

const { ConfigContext } = ConfigProvider;

const CarouselForm = ({
  propsForm = null,
  formReloadCount = 0,
  onFormFinish = () => {},
}) => {
  const [form] = Form.useForm();
  const [files, setFiles] = useState([]);
  const setFormValuesOtherThings = (formValues) => {
    //做一些你可能會用到其他component的資料整理
    let newFormValues = {
      ...formValues,
      total: formValues?.comments * formValues?.number || 0,
    };
    if (propsForm) {
      propsForm.setFieldsValue(newFormValues);
    } else {
      form.setFieldsValue(newFormValues);
    }
  };
  const onChangeFileValue = (values) => {
    let file = values?.file ?? [];
    setFiles(file);
  };
  const setDataInitialization = () => {
    //拿個下拉選單等等的資訊
    // getNewsTypeOption()
    // getNewsWeightTypeOption()
  };
  const onFinish = (values) => {
    console.log(values)
    let news_time = dayjs(values?.news_time).format("YYYY-MM-DD HH:mm:ss");
    let announce_time_end = dayjs(values?.announce_time_end).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    onFormFinish({
      ...values,
      news_time,
      announce_time_end,
    });
  };
  const onValuesChange = () => {
    let formValues = null;
    if (propsForm) {
      formValues = propsForm.getFieldsValue();
    } else {
      formValues = form.getFieldsValue();
    }
    setFormValuesOtherThings(formValues);
  };
  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < dayjs().subtract(1, "day").endOf("day");
  };
  const range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };

  const disabledDateTime = (current) => ({
    disabledHours: () => {
      let hour = dayjs().format("HH");
      let todayDate = dayjs().format("YYYY-MM-DD");
      let currentDate = dayjs(current).format("YYYY-MM-DD");
      if (todayDate === currentDate) {
        return range(0, 24).splice(0, parseInt(hour));
      } else {
        return range(0, 24).splice(0, 0);
      }
    },
    disabledMinutes: () => {
      let minutes = dayjs().format("mm");
      let hour = dayjs().format("HH");
      let todayDate = dayjs().format("YYYY-MM-DD");
      let currentDate = dayjs(current).format("YYYY-MM-DD");
      let currentHour = dayjs(current).format("HH");
      console.log({ minutes });
      if (todayDate === currentDate && currentHour === hour) {
        return range(0, 60).splice(0, parseInt(minutes) + 5);
      } else {
        return range(0, 0);
      }
    },
    disabledSeconds: () => {
      return range(0, 0);
    },
  });
  useEffect(() => {
    setDataInitialization();
  }, []);
  useEffect(() => {
    let formValues = null;
    if (propsForm) {
      formValues = propsForm.getFieldsValue();
    } else {
      formValues = form.getFieldsValue();
    }
    // setFormValuesOtherThings(formValues)
    onChangeFileValue(formValues);
  }, [formReloadCount]);

  const [internalLink, setInternalLink] = useState([]);
  useEffect(() => {
    axios
      .get("/dynamicWebsite/frontend/permission", {
        params: {
          classify_structure_id: 5,
          classify_structure_type_id: 0,
        },
      })
      .then((response) => {
        setInternalLink(
          response?.data["data"].map((map_item) => ({
            title: map_item.name,
            value: `/officialweb/frontend/` + map_item.name,
            children: map_item.children.map((map_item) => ({
              title: map_item.name,
              value: `/officialweb/frontend/` + map_item.name,
              children: map_item.children,
            })),
          }))
        );
        // setMenuItem(response?.data['data'])
      })
      .catch((error) => {})
      .finally(() => {});
  }, []);

  return (
    <Row>
      <Col span={24}>
        <Form
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          layout="horizontal"
          form={propsForm ? propsForm : form}
          onValuesChange={onValuesChange}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Row gutter={[8, 8]}>
            <Col span={24}>
              <Form.Item hidden={true} name={"carousel_id"}>
                <Input></Input>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label={"標題"}
                name={"name"}
                rules={[
                  {
                    required: true,
                    message: "請輸入",
                  },
                ]}
              >
                <Input></Input>
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label={"發佈時間"}
                name={"start_time"}
                rules={[
                  {
                    required: true,
                    message: "請輸入",
                  },
                ]}
              >
                <DatePicker
                  format="YYYY-MM-DD HH:mm:ss"
                  disabledDate={disabledDate}
                  disabledTime={disabledDateTime}
                  showTime={{
                    defaultValue: dayjs("00:00:00", "HH:mm:ss"),
                  }}
                  showNow={false}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label={"結束時間"} name={"end_time"}>
                <DatePicker
                  format="YYYY-MM-DD HH:mm:ss"
                  disabledDate={disabledDate}
                  disabledTime={disabledDateTime}
                  showTime={{
                    defaultValue: dayjs("00:00:00", "HH:mm:ss"),
                  }}
                  showNow={false}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item name={"file"} initialValue={[]} hidden={true}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label={"圖片"}>
                <UploadImg
                  defaultValue={files}
                  onImagesChange={(files) => {
                    propsForm.setFieldValue({
                      file: files,
                    });
                    setFiles(files);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label={"出現頁面"}
              name={'permission_id'}>
                <TreeSelect
                  treeData={internalLink}
                  // defaultValue={departmentId}
                  showSearch
                  style={{
                    width: "100%",
                  }}
                  // value={internalLink}
                  dropdownStyle={{
                    maxHeight: 400,
                    overflow: "auto",
                  }}
                  placeholder="選擇頁面"
                  allowClear
                  treeDefaultExpandAll
                  treeNodeFilterProp={"title"}
                  onChange={(e) => {
                    // setDepartmentId(e)
                  }}
                  multiple={true}
                  treeCheckable={true}
                  // treeData={departmentData}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default CarouselForm;
